import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Footer from '../../DLS/Footer';

const PageNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative flex h-[100vh] h-[calc(100vh-39px)] flex-col overflow-x-hidden bg-gradient1 md:h-[calc(100vh-80px)]">
      <div className="flex flex-1 flex-col overflow-y-auto">
        <div className="mx-auto w-full max-w-[1024px] flex-1">
          <div className="flex min-h-[calc(100vh-80px)] flex-col items-center justify-center px-[16px]">
            <div className="flex max-w-[400px] flex-col items-center">
              <h1 className="m-0 text-center">{t('pageNotFound.title')}</h1>
              <p className="py-[24px] text-center">{t('pageNotFound.text')}</p>
              <Button onClick={() => navigate('/')} type="primary" className="w-full md:w-fit">
                {t('contactUs.backToHome')}
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PageNotFound;
